import type {
  SilaeConfigurationListRecordSchema,
  SilaeConfigurationSchema
} from '@libs/data-access/entities'
import { type QueryFnParams, httpServices } from '@libs/data-access/queries'

export type FetchSilaeConfigurationOptions = QueryFnParams<{}>

export const fetchSilaeConfiguration = async (
  opts?: FetchSilaeConfigurationOptions
) => {
  const response = await httpServices.core.get<SilaeConfigurationSchema>(
    '/silae/configurations',
    opts
  )
  return response.data
}

export type FetchSilaeConfigurationListRecordOptions = QueryFnParams<{}>

export const fetchSilaeConfigurationListRecord = async (
  opts?: FetchSilaeConfigurationListRecordOptions
) => {
  const response =
    await httpServices.core.get<SilaeConfigurationListRecordSchema>(
      '/silae/configurations/liste_dossiers',
      opts
    )
  return response.data
}
